import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Award, Loader2 } from "lucide-react";

const scoreCls = (s) =>
  s >= 85 ? "bg-emerald-100 text-emerald-700 ring-emerald-200"
  : s >= 60 ? "bg-amber-100 text-amber-700 ring-amber-200"
  : "bg-red-100 text-red-700 ring-red-200";

// Tedarikçi performans skoru rozeti — /suppliers/{id}/summary performance.score (0-100)
export default function SupplierScoreBadge({ supplierId, showLabel = true }) {
  const [p, setP] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (!supplierId) return;
    let on = true;
    setLoading(true);
    api.get(`/suppliers/${supplierId}/summary`)
      .then((r) => { if (on) setP(r.data?.performance || null); })
      .catch(() => { if (on) setP(null); })
      .finally(() => { if (on) setLoading(false); });
    return () => { on = false; };
  }, [supplierId]);

  if (loading) {
    return <span data-testid="supplier-score-loading" className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] text-slate-400"><Loader2 className="h-3 w-3 animate-spin" /> skor</span>;
  }
  if (!p || p.score == null) {
    return <span data-testid="supplier-score-none" className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-500"><Award className="h-3 w-3" /> Skor yok</span>;
  }
  return (
    <span data-testid="supplier-score-badge"
      title={`Tamamlanma %${p.completion_rate ?? "—"} · Sorunsuz %${p.clean_rate ?? "—"} · Zamanında %${p.on_time_rate ?? "—"}`}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ring-1 ring-inset ${scoreCls(p.score)}`}>
      <Award className="h-3 w-3" /> {showLabel ? "Tedarikçi Skoru " : ""}{p.score}/100
    </span>
  );
}
